<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_1"><em>Part I</em></a></h1><a id="page_1">
<h1 class="part-title">FROM VIENNA TO AMSTERDAM</h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Part01.vue?3717556f